import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/img/defaultprofile.jpg'


const _hoisted_1 = {
  key: 0,
  class: "dashboard"
}
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "d-flex align-items-center mb-4" }
const _hoisted_4 = { class: "dashboardImage" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  src: _imports_0,
  key: "def"
}
const _hoisted_7 = {
  key: 2,
  class: "changeImage"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-camera" }, null, -1)
const _hoisted_9 = { class: "dashboardName ml-2" }
const _hoisted_10 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_11 = { class: "d-flex mt-1" }
const _hoisted_12 = { class: "fs-22" }
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = { class: "fs-22" }
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = { class: "fs-22" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_input = _resolveComponent("file-input")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_dashboard_lead = _resolveComponent("dashboard-lead")!
  const _component_dashboard_collaboratore = _resolveComponent("dashboard-collaboratore")!
  const _component_dashboard_manager = _resolveComponent("dashboard-manager")!
  const _component_dashboard_centro = _resolveComponent("dashboard-centro")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.user.personalData.profilePicture)
                ? (_openBlock(), _createElementBlock("img", {
                    src: _ctx.user.personalData.profilePicture,
                    key: "img"
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6)),
              (!_ctx.$route.params.userIdentifier || _ctx.$store.state.isAdmin() || _ctx.$store.state.isManager())
                ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                    _createVNode(_component_file_input, {
                      class: "hidden",
                      modelValue: _ctx.imageToUpload,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageToUpload) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_8
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.user)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_10, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Ciao 👋",
                      text: "Ciao 👋"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.user.personalData.completeName), 1),
                    (!_ctx.$store.state.isLead(_ctx.user.role))
                      ? (_openBlock(), _createBlock(_component_localized_text, {
                          key: 0,
                          localizedKey: ", facciamo soldi! 🚀",
                          text: ", facciamo soldi! 🚀"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Codice referral:",
                    text: "Codice referral:"
                  }),
                  _createElementVNode("b", _hoisted_12, _toDisplayString(_ctx.user.referralCode), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Qualifica:",
                    text: "Qualifica:"
                  }),
                  _createElementVNode("b", _hoisted_14, _toDisplayString(_ctx.user.pianoProvvigioni.qualifica.codiceQualifica), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Upliner:",
                    text: "Upliner:"
                  }),
                  _createElementVNode("b", _hoisted_16, _toDisplayString(_ctx.user.reteCommercialeParent && _ctx.user.reteCommercialeParent.name), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.profileModal && _ctx.profileModal(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Modifica dati personali",
                text: "Modifica dati personali"
              })
            ])
          ])
        ]),
        (_ctx.$store.state.isLead(_ctx.user.role) || _ctx.$store.state.isCliente(_ctx.user.role))
          ? (_openBlock(), _createBlock(_component_dashboard_lead, {
              key: 0,
              user: _ctx.user,
              reload: _ctx.reload
            }, null, 8, ["user", "reload"]))
          : _createCommentVNode("", true),
        (_ctx.$store.state.isCollaboratore(_ctx.user.role))
          ? (_openBlock(), _createBlock(_component_dashboard_collaboratore, {
              key: 1,
              user: _ctx.user,
              reload: _ctx.reload
            }, null, 8, ["user", "reload"]))
          : _createCommentVNode("", true),
        (_ctx.$store.state.isManager(_ctx.user.role) || _ctx.$store.state.isAdmin(_ctx.user.role))
          ? (_openBlock(), _createBlock(_component_dashboard_manager, {
              key: 2,
              user: _ctx.user,
              reload: _ctx.reload
            }, null, 8, ["user", "reload"]))
          : _createCommentVNode("", true),
        (_ctx.$store.state.isCentro(_ctx.user.role) || _ctx.$store.state.isDottore(_ctx.user.role))
          ? (_openBlock(), _createBlock(_component_dashboard_centro, {
              key: 3,
              user: _ctx.user,
              reload: _ctx.reload
            }, null, 8, ["user", "reload"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}